// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3iTIO","productName":"Table_productName__2Q3-T"};